export const MJ = 'MJ'
export const VEG = 'VEG'

export default [
  MJ,
  VEG,
]
